import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a694610"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["role", "tabindex", "onKeydown"]
const _hoisted_2 = { class: "info" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "date" }
const _hoisted_7 = {
  key: 0,
  class: "desc"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

import { IUserRequest } from '@/types/user-request';
import { request, confirm } from '@/utils';
import { useI18n } from 'vue-i18n';
import { USER_REQUEST_STATE_MAP } from '@/constants';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

interface Props {
  modelValue: IUserRequest,
}

interface Emits {
  (event: 'update:model-value', modelValue: IUserRequest): void;
  (event: 'update'): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null
  },
  emits: ["update:model-value", "update"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:model-value', modelValue: IUserRequest): void;
  (event: 'update'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: IUserRequest,
}



const { t, locale } = useI18n();
const router = useRouter();
const stateClass = computed(() => {
  const state = props.modelValue.state;
  if (['approved', 'wait_listed'].includes(state)) {
    return 'green';
  }
  return 'gray';
});

const showCancel = computed(() => {
  const state = props.modelValue.state;
  return ['pending', 'approved', 'wait_listed'].includes(state);
});
const targetProgramRoute = computed(() => {
  const slug = props.modelValue.target?.slug;
  if (!slug) {
    return null;
  }
  return {
    name: 'programs.show',
    params: { slug }
  };
});
const isProgramLinkEnabled = computed(() => Boolean(targetProgramRoute.value));

async function handleNavigateToProgram() {
  if (!targetProgramRoute.value) {
    return;
  }
  await router.push(targetProgramRoute.value);
}

 async function handleCancel() {
   await confirm(t('close_confirm_text'), { class: `modal-record-item-delete-${locale.value}` });
   await request.put(`user_requests/${props.modelValue.id}/close_participation_request`);
   emits('update:model-value', {
     ...props.modelValue,
     state: 'closed'
   });
 }

async function handleReParticipation() {
  await confirm(t('re_confirm_text'), { class: `modal-record-item-delete-${locale.value}` });
  await request.post(`programs/${props.modelValue.target_id}/participate`);
  emits('update');
}

return (_ctx: any,_cache: any) => {
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["participation-history-item", { clickable: _unref(isProgramLinkEnabled) }]),
    style: _normalizeStyle(_unref(isProgramLinkEnabled) ? { cursor: 'pointer' } : undefined),
    role: _unref(isProgramLinkEnabled) ? 'link' : undefined,
    tabindex: _unref(isProgramLinkEnabled) ? 0 : undefined,
    onClick: handleNavigateToProgram,
    onKeydown: [
      _withKeys(_withModifiers(handleNavigateToProgram, ["prevent"]), ["enter"]),
      _withKeys(_withModifiers(handleNavigateToProgram, ["prevent"]), ["space"])
    ]
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: __props.modelValue.target.image?.url,
        class: "cover"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["status", _unref(stateClass)])
        }, _toDisplayString(_unref(USER_REQUEST_STATE_MAP)[__props.modelValue.state]), 3),
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.modelValue.target.name), 1),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.$t('Participation date')) + ": ", 1),
          _createVNode(_component_AppTimeFormat, {
            time: __props.modelValue.created_at,
            format: "YYYY-MM-DD"
          }, null, 8, ["time"])
        ]),
        (__props.modelValue.collection_challenge)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('collection_challenge')) + " : " + _toDisplayString(__props.modelValue.collection_challenge), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: "action",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      (_unref(showCancel))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "btn cancel",
            onClick: _withModifiers(handleCancel, ["stop"])
          }, _toDisplayString(_unref(t)('Cancel')), 9, _hoisted_8))
        : _createCommentVNode("", true),
      (__props.modelValue.state === 'closed')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "btn re",
            onClick: _withModifiers(handleReParticipation, ["stop"])
          }, _toDisplayString(_unref(t)('Re-participation')), 9, _hoisted_9))
        : _createCommentVNode("", true)
    ])
  ], 46, _hoisted_1))
}
}

})